import React from "react";
import Navb from "../../../../components/navbar/Navb";
import Footer from "../../../../components/footer/Footer";
import RecipiePage from "../../../../components/recipiePage/RecipiePage";
import Recpiesimg1 from "./recpiesimg1.png";
import Recpiesimg2 from "./recpiesimg2.png";
import Recpiesimg3 from "../../img7.png";
import Recpiesimg4 from "../../img2.png";
import Recpiesimg5 from "../../img11.png";
import Img1 from "./img1.png";
import Timer from "../timer.png";
import "../recipe.css";
const Daliasalad = () => {
  return (
    <>
    <RecipiePage
        Recpiesimg1={Recpiesimg1}
        Recpiesimg2={Recpiesimg2}
        Recpiesimg3={Recpiesimg3}
        Recpiesimg4={Recpiesimg4}
        Recpiesimg5={Recpiesimg5}
        Img1={Img1}
        Name="Dalia Salad"
        Ul1={
          <ul>
            <li>
            <span className="Bold">Nandi dalia (cracked wheat)</span>
            </li>
            <li>mixed bell peppers, diced</li>
            <li>cherry tomatoes, halved</li>
            <li>cucumber, diced </li>
            <li>red onion, finely chopped</li>
            <li>feta cheese, crumbled</li>
          </ul>
        }
        Ul2={
          <ul className="noDecoration">
            <li>1 cups</li>
            <li>1 cups</li>
            <li>1 cups</li>
            <li>1/2 cups</li>
            <li>1/4 cups</li>
            <li>1/4 cups</li>
          </ul>
        }
        Ul3={
          <ul>
            <li>olive oil</li>
            <li>balsamic vinegar</li>
            <li>Salt and pepper</li>
            <li>basil leaves for garnishing</li>
          </ul>
        }
        Ul4={
          <ul className="noDecoration">
            <li>2 tablespoons</li>
            <li>1 tablespoons</li>
            <li>to taste</li>
            <li>Fresh</li>
          </ul>
        }
        Ol1={
          <ol>
            <li>
              Cook the dalia according to the package instructions. Allow it to
              cool completely.
            </li>
            <li>
              In a large mixing bowl, combine the cooled dalia, diced bell
              peppers, cherry tomatoes, cucumber, red onion, and crumbled feta
              cheese.
            </li>

            <li>
              In a small bowl, whisk together olive oil, balsamic vinegar, salt,
              and pepper to create the dressing.
            </li>

            <li>
              Pour the dressing over the salad and toss gently to coat all the
              ingredients.
            </li>
            <li>Garnish with fresh basil leaves.</li>
            <li>
              Chill the salad for at least 30 minutes before serving to allow
              the flavors to meld.
            </li>
          </ol>
        }
        Item1="Besan Burfi"
        Item2="Mix Veg Paratha"
        Item3="Dalia Khichadi"
        Link1="besanburfi"
        Link2="mixvegparatha"
        Link3="daliakhichadi"
      />
      {/* <Navb />
      <div className="singleRecipeTop">Dalia Salad</div>
      <img className="singleRecipeTopimg" src={Recpiesimg1} alt="Recpiesimg1" />
      <div className="singleRecipeBot">
        <div className="singleRecipeBotLeftItems">
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <hr />
          <div className="singleRecipeBotLeftItem">

            <ol>
              <li>
                1 cup <span className="Bold">Nandi dalia (cracked wheat)</span>,
                cooked and cooled
              </li>
              <li>1 cup mixed bell peppers, diced</li>
              <li>1 cup cherry tomatoes, halved</li>
              <li>1/2 cup cucumber, diced</li>
              <li>1/4 cup red onion, finely chopped</li>
              <li>1/4 cup feta cheese, crumbled</li>
              <li>2 tablespoons olive oil</li>
              <li>1 tablespoon balsamic vinegar</li>
              <li>Salt and pepper to taste</li>
              <li>Fresh basil leaves for garnishing</li>
            </ol>
          </div>

          <hr />
          <div className="flexitemrecipe">
            <img src={Recpiesimg2} alt="Recpiesimg2" />
            Nandi Dalia
          </div>
        </div>
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          <ol>
            <li>
              Cook the dalia according to the package instructions. Allow it to
              cool completely.
            </li>
            <li>
              In a large mixing bowl, combine the cooled dalia, diced bell
              peppers, cherry tomatoes, cucumber, red onion, and crumbled feta
              cheese.
            </li>

            <li>
              In a small bowl, whisk together olive oil, balsamic vinegar, salt,
              and pepper to create the dressing.
            </li>

            <li>
              Pour the dressing over the salad and toss gently to coat all the
              ingredients.
            </li>
            <li>Garnish with fresh basil leaves.</li>
            <li>
              Chill the salad for at least 30 minutes before serving to allow
              the flavors to meld.
            </li>
          </ol>
        </div>
      </div>
      <div className="singleRecipeEnd">
        <div className="singleRecipeEndTitle">You Might Also Like</div>
        <div className="singleRecipeEndItems">
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/sojivegcheela">
                <img src={Recpiesimg3} alt="Recpiesimg3" />
                <div className="singleRecipeEndItemTitle">
                  Sooji and Vegitable Cheela
                </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 30 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/daliakhichadi">
                <img src={Recpiesimg4} alt="Recpiesimg4" />
                <div className="singleRecipeEndItemTitle">Dalia Khichadi</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 20 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
              <a href="/recipes/soojidhokla">
                <img src={Recpiesimg5} alt="Recpiesimg5" />
                <div className="singleRecipeEndItemTitle">Sooji Dhokla</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 30 mins</span>
            </div>
          </div>
        </div>
      </div>
      <Footer /> */}
    </>
  );
};

export default Daliasalad;
